// Based on https://stackoverflow.com/a/26533266
export function getFullText(ctx) {
	if (!ctx.start || !ctx.stop || ctx.start.start < 0 || ctx.stop.stop < 0) {
		return ctx.getText();
	}
	return ctx.start.getInputStream().getText(ctx.start.start, ctx.stop.stop);
}
